import { Stroke, Style } from "ol/style";
import { RAMP_HIGHWAY_TYPES } from "./supportedHighwayTypes";
import {
  getNodeStyleNormal,
  getNodeStyleClick,
  getNodeStyleHover,
} from "./node";

export function getRampStyleNormal(feature) {
  return getRampColorStyle(feature).concat(getNodeStyleNormal(feature));
}
export function getRampStyleClick(feature) {
  return getRampColorStyle(feature, true, false).concat(
    getNodeStyleClick(feature),
  );
}
export function getRampStyleHover(feature) {
  return getRampColorStyle(feature, false, true).concat(
    getNodeStyleHover(feature),
  );
}
function getRampColorStyle(feature, click, hover) {
  let color, width;
  const ramp = findValueByKeyEndingWith(feature.getProperties(), "ramp");
  const highway = findValueByKeyEndingWith(feature.getProperties(), "highway");
  if (highway === undefined) {
    color = "black";
    width = 1;
  } else if (!RAMP_HIGHWAY_TYPES.includes(highway)) {
    color = "grey";
    width = 1;
  } else if (ramp === "yes") {
    color = "#CD2C58"; // cardinal red
    width = 3;
  } else {
    color = "#abdbe3"; // light blue
    width = 1;
  }
  if (click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: width * 3,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: "#eab676", // orange
          width: width * 2,
        }),
      }),
    ];
  }
  if (hover) {
    return [
      new Style({
        stroke: new Stroke({
          color: "white",
          width: width * 4,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: width * 2,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
function findValueByKeyEndingWith(obj, suffix) {
  const key = Object.keys(obj).find((key) => key.endsWith(suffix));
  return obj[key];
}
